import React from 'react';
import { SparkleIcon } from '@Generic/icons';

const AbsenceManagementTab = React.lazy(() => import('./AbsenceManagementTab'));

export const HOME_PAGE_TABS = [
  { id: 'updates', permission: 'updates', component: React.lazy(() => import('./UpdatesTab')) },
  { id: 'profile', permission: 'profileInfo', component: React.lazy(() => import('./ProfileTab')) },
  { id: 'role', permission: 'role', component: React.lazy(() => import('./JobDetailsTab')) },
  { id: 'team', permission: 'team', component: React.lazy(() => import('./TeamTab')) },
  { id: 'tasks', permission: 'task', component: React.lazy(() => import('./TasksTab')), className: 'tasks-tab-panel' },
  {
    id: 'time_off',
    iconStart: <SparkleIcon />,
    permission: 'timeOffPaywall',
    component: React.lazy(() => import('./PaywallTimeOffTab')),
  },
  {
    id: 'time_off',
    permission: 'timeOff',
    component: React.lazy(() => import('./TimeOffTab')),
    tabIdentifier: 'oldTimeoff',
  },
  {
    id: 'absence-management',
    permission: 'timeOff',
    component: AbsenceManagementTab,
    skipCompanySettingsCheck: true,
  },
  {
    id: 'absence-management-approvals',
    permission: 'timeOff',
    component: AbsenceManagementTab,
    activeId: 'absence-management',
    hiddenInNav: true,
    skipCompanySettingsCheck: true,
  },
  {
    id: 'calendar',
    permission: 'calendar',
    hiddenInMobile: true,
    component: React.lazy(() => import('./CalendarTab')),
  },
  { id: 'documents', permission: 'document', component: React.lazy(() => import('./DocumentsTab')) },
];

const getHomePageTabs = (t) =>
  HOME_PAGE_TABS.map((tab) => ({
    ...tab,
    label: t(`home-page.tabs.${tab.id}`),
  }));

export default getHomePageTabs;
